import { createFeatureScope } from 'bundles/product-features';

export const { useProductFeatures } = createFeatureScope({
  authoring: {
    enableRetirePrograms: false,
  },
});
